/* Petizen homepage — lightweight responsive carousels with drag/swipe (from design handoff).
   .pz-car: data-per (visible desktop) · data-per-md (<=1024) · data-per-sm (<=600)
            · data-gap · data-step · data-auto (ms)
   Structure:
     .pz-car > .pz-car-view > .pz-car-track > [slides]
            + .pz-car-ctrl > [data-prev] .pz-dots[data-dots] [data-next]
   Pointer drag works on mouse + touch. Safe to load from multiple sections. */
(function () {
  function perFor(car) {
    var w = document.documentElement.clientWidth || window.innerWidth;
    if (w <= 600 && car.dataset.perSm) return parseFloat(car.dataset.perSm);
    if (w <= 1024 && car.dataset.perMd) return parseFloat(car.dataset.perMd);
    return parseFloat(car.dataset.per || '1');
  }

  function initCar(car) {
    if (car.dataset.pzInit) return;          // guard: never init twice
    car.dataset.pzInit = '1';
    var view = car.querySelector('.pz-car-view');
    var track = car.querySelector('.pz-car-track');
    if (!track) return;
    var slides = [].slice.call(track.children);
    if (!slides.length) return;              // no slides (e.g. all blocks removed) — nothing to size or measure
    var heroAnim = car.classList.contains('pz-hero-anim');   // hero text-entrance: mark the active slide
    function setActive(i) { if (!heroAnim) return; for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('is-active', k === i); }
    var gap = parseFloat(car.dataset.gap || '16');
    var dotsWrap = car.querySelector('[data-dots]');
    var prev = car.querySelector('[data-prev]');
    var next = car.querySelector('[data-next]');
    track.style.setProperty('--car-gap', gap + 'px');
    var per = 1, step = 1, pages = 1, idx = 0, dots = [];
    var timer = null;

    function shiftForPage(p) {
      var slideW = slides[0].getBoundingClientRect().width + gap;
      var maxShift = track.scrollWidth - view.getBoundingClientRect().width;
      return Math.min(p * step * slideW, Math.max(0, maxShift));
    }

    function go(p) {
      idx = Math.max(0, Math.min(p, pages - 1));
      track.style.transform = 'translateX(' + (-shiftForPage(idx)) + 'px)';
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === pages - 1;
      setActive(idx);
    }

    /* expose: jump to the page showing a given slide index (used by the theme editor) */
    car.pzGoToSlide = function (i) {
      var p = step > 0 ? Math.floor(i / step) : i;
      go(Math.max(0, Math.min(p, pages - 1)));
    };

    function build() {
      per = perFor(car);
      step = parseFloat(car.dataset.step || per);
      var basis = 'calc((100% - ' + ((per - 1) * gap) + 'px) / ' + per + ')';
      slides.forEach(function (s) { s.style.flex = '0 0 ' + basis; s.style.maxWidth = basis; });
      pages = Math.max(1, Math.ceil((slides.length - per) / step) + 1);
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        dots = [];
        for (var i = 0; i < pages; i++) {
          var b = document.createElement('button');
          b.className = 'pz-dot' + (i === 0 ? ' is-on' : '');
          b.setAttribute('aria-label', 'Go to page ' + (i + 1));
          (function (n) { b.addEventListener('click', function () { go(n); }); })(i);
          dotsWrap.appendChild(b); dots.push(b);
        }
      }
      if (idx > pages - 1) idx = pages - 1;
      go(idx);
    }

    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });

    var auto = parseInt(car.dataset.auto || '0', 10);
    if (window.Shopify && window.Shopify.designMode) auto = 0;   // don't auto-advance while editing in the theme editor
    function startAuto() { if (auto > 0 && !timer) timer = setInterval(function () { go(idx >= pages - 1 ? 0 : idx + 1); }, auto); }
    function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
    startAuto();
    car.addEventListener('mouseenter', stopAuto);
    car.addEventListener('mouseleave', startAuto);

    /* ---- pointer drag / swipe ------------------------------------------- */
    view.style.touchAction = 'pan-y';
    view.style.cursor = 'grab';
    var dragging = false, moved = false, locked = false, startX = 0, startY = 0, baseShift = 0, pid = null;

    function onDown(e) {
      if (pages <= 1 || (e.pointerType === 'mouse' && e.button !== 0)) return;
      dragging = true; moved = false; locked = false;
      startX = e.clientX; startY = e.clientY; baseShift = shiftForPage(idx); pid = e.pointerId;
      stopAuto();
      /* NB: don't capture the pointer or kill the track transition yet. Wait until the
         gesture is confirmed horizontal (onMove) — otherwise a vertical page-scroll or a
         plain tap/click would get hijacked by the slider. */
    }
    function onMove(e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (!locked) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;     // too small to tell direction yet
        if (Math.abs(dy) >= Math.abs(dx)) { dragging = false; startAuto(); return; }   // vertical → let the page scroll
        locked = true; moved = true;                          // horizontal → take over as a swipe
        track.style.transition = 'none';
        view.style.cursor = 'grabbing';
        try { view.setPointerCapture(pid); } catch (err) {}
      }
      track.style.transform = 'translateX(' + (-(baseShift - dx)) + 'px)';
    }
    function onUp(e) {
      if (!dragging) return;
      dragging = false;
      view.style.cursor = 'grab';
      track.style.transition = '';
      try { view.releasePointerCapture(pid); } catch (err) {}
      if (!moved) { startAuto(); return; }                    // a tap, not a swipe — leave the slide, let the click fire
      var dx = e.clientX - startX;
      var slideW = slides[0].getBoundingClientRect().width + gap;
      var moveBy = 0;
      if (Math.abs(dx) > Math.min(60, slideW * 0.25)) moveBy = dx < 0 ? Math.max(1, Math.round(-dx / (slideW * step))) : -Math.max(1, Math.round(dx / (slideW * step)));
      go(idx + moveBy);
      startAuto();
    }
    view.addEventListener('pointerdown', onDown);
    view.addEventListener('pointermove', onMove);
    view.addEventListener('pointerup', onUp);
    view.addEventListener('pointercancel', onUp);
    /* swallow the click that follows a real drag so links don't fire */
    view.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    view.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var raf = 0;
    function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; build(); }); }
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(schedule).observe(view);
    window.addEventListener('resize', schedule);
    build();
  }

  /* ---- scroll reveal: sections fade + slide up on entering the viewport -- */
  function initReveal() {
    if (window.pzAnimOff) return;                                  // merchant toggle (theme settings)
    if (window.Shopify && window.Shopify.designMode) return;       // calm in the editor
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var stagger = !window.pzStaggerOff;
    var step = parseInt(window.pzStaggerStep, 10); if (isNaN(step)) step = 70;
    // items that pop in one-by-one within a section
    var sel = '.pz-card, .pz-cattile, .pz-rev-card, .pz-trust-item, .pz-pettile, .pz-insta-strip > a, .pz-brands-grid > *, .pz-brands-col';
    var targets = [];
    document.querySelectorAll('.pz-section, .pz-band, .pz-about').forEach(function (el) {
      if (el.dataset.pzReveal) return;
      el.dataset.pzReveal = '1';
      var items = stagger ? [].slice.call(el.querySelectorAll(sel)) : [];
      var t = { el: el, items: null, done: false };
      if (items.length > 1) {
        items.forEach(function (it, i) { it.classList.add('pz-stagger'); it.style.transitionDelay = (Math.min(i, 9) * step) + 'ms'; });
        t.items = items;                                           // stagger the cards, leave the heading in place
      } else {
        el.classList.add('pz-reveal');                            // single-block sections fade as one
      }
      targets.push(t);
    });
    function reveal(t) {
      if (t.done) return; t.done = true;
      if (t.items) t.items.forEach(function (it) { it.classList.add('pz-in'); });
      else t.el.classList.add('pz-in');
    }

    /* Reveal line — a section animates in once its TOP edge has risen above this
       fraction of the viewport height (0 = top of screen, 1 = bottom). 0.60 means
       the section has filled the bottom ~40% of the screen and is entering the
       centre band before it plays. Lower it toward 0.5 to fire nearer dead-centre,
       raise it toward 0.85 to fire earlier (as it peeks in at the bottom).
       Tunable from Theme settings → Petizen homepage via window.pzRevealLine. */
    var line = parseFloat(window.pzRevealLine);
    if (isNaN(line) || line <= 0 || line > 1) line = 0.60;

    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var pageBottom = (window.scrollY || window.pageYOffset) + vh >= document.documentElement.scrollHeight - 4;
      var pending = false;
      targets.forEach(function (t) {
        if (t.done) return;
        // fire when the section top crosses the reveal line, OR the page can't scroll
        // any further (covers a short trailing section that never reaches the line).
        if (t.el.getBoundingClientRect().top < vh * line || pageBottom) reveal(t);
        else pending = true;
      });
      if (!pending) {                                              // everything shown — stop listening
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }
    // Scroll-based reveal — reliable on iOS Safari (IntersectionObserver can be flaky there).
    var ticking = false;
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; check(); }); }
    check();                                                       // reveal above-the-fold immediately (no flash)
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // Re-run check() once layout settles (web-fonts / images shift section tops).
    // check() only reveals what's actually in view, so below-the-fold sections wait
    // for the user to scroll to them — no blanket timer that reveals everything early.
    window.addEventListener('load', check);
    setTimeout(check, 400);
    setTimeout(check, 1200);
  }

  /* Theme editor: when a block (slide) is selected/edited, keep the carousel on
     that slide instead of snapping back to the first one after each re-render. */
  function onBlockSelect(e) {
    var node = e.target;
    if (!node || !node.closest) return;
    var car = node.closest('.pz-car');
    if (!car || !car.pzGoToSlide) return;
    var track = car.querySelector('.pz-car-track');
    if (!track) return;
    var children = [].slice.call(track.children);
    for (var i = 0; i < children.length; i++) {
      if (children[i] === node || children[i].contains(node)) { car.pzGoToSlide(i); return; }
    }
  }

  function boot() {
    document.querySelectorAll('.pz-car').forEach(initCar);
    initReveal();
    var top = document.querySelector('.pz-top-fab');
    if (top && !top.dataset.pzInit) {
      top.dataset.pzInit = '1';
      top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  /* wire editor block-follow once (design mode only) */
  if (window.Shopify && window.Shopify.designMode && !window.__pzEditorWired) {
    window.__pzEditorWired = true;
    document.addEventListener('shopify:block:select', onBlockSelect);
  }
})();
